import { render, staticRenderFns } from "./scrollbar.vue?vue&type=template&id=26532afe&"
import script from "./scrollbar.vue?vue&type=script&lang=js&"
export * from "./scrollbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports